import { Component, OnInit } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { bounce, zoomOut, zoomIn, fadeIn, bounceIn } from 'ng-animate';
import { NavService } from "../../../shared/service/nav.service";

@Component({
  selector: 'app-public-content-layout',
  templateUrl: './public-content-layout.component.html',
  styleUrls: ['./public-content-layout.component.scss'],
  animations: [
    trigger('animateRoute', [transition('* => *', useAnimation(fadeIn, {
      // Set the duration to 5seconds and delay to 2 seconds
      //params: { timing: 3}
    }))])
  ]
})
export class PublicContentLayoutComponent implements OnInit {

  public rightSideBar: boolean;

  constructor(public navServices: NavService) {
  }

  public getRouterOutletState(outlet: any): void {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  public rightSidebar($event: any): void {
    this.rightSideBar = $event;
  }

  ngOnInit(): void {
  }

}
